//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbLabel from '@/elements/label/label.vue'
export default {
  name: 'rb-radio-accordion',
  components: {
    RbLabel,
  },
  props: {
    alreadyOpen: {
      type: Boolean,
      default: false,
    },
    idTrackingElement: {
      type: String,
      default: '',
    },
    isDark: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.$props.alreadyOpen) {
      this.$refs.radio.checked = true
    } else {
      this.$el.querySelector('.accordion-body').style.display = 'none'
    }
  },
  methods: {
    toggleAccordion() {
      this.$refs.radio.checked = !this.$refs.radio.checked

      if (this.$refs.radio.checked) {
        const accordions = document.querySelectorAll('.accordion-body')
        accordions.forEach(function (item) {
          item.style.display = 'none'
        })
        this.$el.querySelector('.accordion-body').style.display = 'flex'
        this.$el.querySelector('.accordion-body').style.flexDirection = 'column'
      } else {
        this.$el.querySelector('.accordion-body').style.display = 'none'
      }

      if (this.$refs.radio.checked === true && this.idTrackingElement != '') {
        this.$ma.trackEvent({
          event: 'Click',
          value: {
            data_element_id: this.idTrackingElement,
          },
        })
      }
    },
  },
}
